// extracted by mini-css-extract-plugin
module.exports = {"cta-button":"cta-button_cta-button__4XihL"};